export default "__VITE_ASSET__BMYviE5T__"